import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import { PlatformApp } from '@typings';

type Tag = PlatformApp.Template['tags'][number];

export const useTagsSearchParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tags = searchParams.getAll('tags');

  const toggleTag = useCallback(
    (tag: Tag) => {
      const newParams = new URLSearchParams(searchParams.toString());
      const currentTags = newParams.getAll('tags');

      if (currentTags.includes(tag)) {
        newParams.delete('tags');
        currentTags.forEach((t) => {
          if (t !== tag) {
            newParams.append('tags', t);
          }
        });
      } else {
        newParams.append('tags', tag);
      }

      setSearchParams(newParams);

      return newParams;
    },
    [searchParams, setSearchParams],
  );

  const addTag = useCallback(
    (tag: Tag) => {
      const newParams = new URLSearchParams(searchParams.toString());

      newParams.append('tags', tag);

      setSearchParams(newParams);

      return newParams.toString();
    },
    [searchParams, setSearchParams],
  );

  return {
    searchParams,
    tags,
    addTag,
    toggleTag,
  };
};
